module.exports = __webpack_public_path__ + "static/img/9671924e9a55277116fbe9c2a5f99fbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/T32.jpg
// module id = MeQv
// module chunks = 1